import RecentNPCsInventory from "./RecentNPCsInventory";
import ShowcaseNPCInventory from "./ShowcaseNPCsInventory";

const PublicNPCsDashboard = () => {
  return (
    <div className="mt-8">
      <RecentNPCsInventory />

      <div className="block" aria-hidden="true">
        <div className="py-5">
          <div className="border-t border-gray-200" />
        </div>
      </div>

      <ShowcaseNPCInventory />
    </div>
  );
};

export default PublicNPCsDashboard;
